import React, { useContext, useEffect, useState } from 'react'

import GeneralContext from '../../../context/GeneralContext/GeneralContext';
import api from '../../services/api'
import Iframe from '../../components/iframe/Iframe'
import { displayMessage } from '../../services/helper';
export default function ExercisesTutorials() {
    const {
        setShowLoading
    } = useContext(GeneralContext)

    const [exercisesUrls, setExercisesUrls] = useState([])

    useEffect(() => {
        findEnum()
    }, [])

    async function findEnum() {
        setShowLoading(true)
        try {
            const { data } = await api.enums.find('ETutorialsUrls')
            setExercisesUrls(data?.EXERCISES_URLS || [])
        } catch (error) {
            console.log(error)
        } finally {
            setTimeout(() => {
                setShowLoading(false)
            }, 450);
        }
    }
    
    return (
        <div className='p-3 rounded-3xl text-appian-blue bg-gray-100'>
            <div className='flex text-center text-2xl font-bold justify-center items-center text-appian-blue pb-5'>
                {displayMessage('EXERCISES_TUTORIAL_TITLE')}
            </div>
            {
                exercisesUrls.map(url => {
                    return (
                        <div className='mb-14 mt-7' key={url}>
                            <Iframe 
                                url={url}
                            />
                        </div>
                    )
                })
            }
        </div>
    )
}